import React, { Component } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

import { connect } from "react-redux";
import _ from "lodash";
import Sidebar from "../common/sidebar";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import { communityActions } from "../../_actions";
import { DashboardIcon } from "../Svg";
import Loader from "../common/Loader";
import "./imageModal.css";

class CommunityList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortField: "",
      sortType: -1,

      show: false,
      count: 10,
      userListCount: 0,

      totalCount: 0,
      pageNo: 1,

      userInfo: [],
      loader: true,
      showConfirmModal: false,
      confirmModalAction: null,
      selectedPostId: null,
      confirmModalTitle: "",
      confirmModalMessage: "",
      postType: "",

      showStoryModal: false,
      selectedStory: "",
    };
  }

  truncateText = (text = "", limit = 50) => {
    if (!text) return "-";
    return text.length > limit ? text.slice(0, limit) : text;
  };

  openStoryModal = (story) => {
    this.setState({
      showStoryModal: true,
      selectedStory: story || "-",
    });
  };

  closeStoryModal = () => {
    this.setState({
      showStoryModal: false,
      selectedStory: "",
    });
  };

  handlePostType = (e) => {
    const value = e.target.value;

    this.setState(
      {
        postType: value,
        pageNo: 1, // reset to first page
        loader: true,
      },
      () => {
        this.getCommunityPosts();
      }
    );
  };

  componentDidMount() {
    this.getCommunityPosts();
  }

  getCommunityPosts = () => {
    this.setState({ errors: "" });

    let self = this;

    let { dispatch } = this.props;
    // dispatch(orderActions.getAllOrderExcel(params)).then(data => {
    let { pageNo, count, sortField, sortType, search, postType } = this.state;

    // dispatch(orderActions.getAllOrderExcel(params)).then(data => {
    let trimmedSearch = search ? search.trim() : "";
    let params = `?pageNo=${pageNo - 1}
&count=${count ? count : 10}
&sortField=${sortField ? sortField : ""}
&sortType=${sortType ? sortType : ""}
&search=${trimmedSearch}
${postType ? `&postType=${encodeURIComponent(postType)}` : ""}`;

    return dispatch(communityActions.getCommunityPosts(params)).then((data) => {
      this.setState({ loader: false });
      let userInfo = data.responseData.posts;
      let userListCount = data.responseData.pagination.total;
      let totalCount = data.responseData.pagination.total;
      if (data.statusCode == 1) {
        this.setState({
          userInfo: userInfo,
          userListCount: userListCount,
          totalCount: totalCount,
        });
      } else {
        this.setState({ errors: data.error.responseMessage });
      }
    });
  };
  handlePageChange = (pageNo) => {
    var self = this;
    this.setState({ loader: false, pageNo: pageNo, count: 10 }, () => {
      self.getCommunityPosts();
    });
  };

  handleFilter = (ele) => {
    this.setState({
      loader: false,
      count: 10,
      pageNo: 1,
    });
  };
  ConvertDate = (created) => {
    if (!created) return "";
    let data = moment(created).format("MM/DD/YYYY");
    return data;
  };

  openConfirmModal = (postId, action) => {
    const isPublish = action === "publish";
    this.setState({
      showConfirmModal: true,
      confirmModalAction: action,
      selectedPostId: postId,
      confirmModalTitle: isPublish ? "Publish Post" : "Unpublish Post",
      confirmModalMessage: isPublish
        ? "Are you sure you want to publish this post?"
        : "Are you sure you want to unpublish this post?",
    });
  };

  closeConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      confirmModalAction: null,
      selectedPostId: null,
      confirmModalTitle: "",
      confirmModalMessage: "",
    });
  };

  handleConfirmAction = () => {
    const { confirmModalAction, selectedPostId } = this.state;
    const { dispatch } = this.props;

    if (!selectedPostId) return;

    const params = { postId: selectedPostId };

    this.setState({ loader: true }, () => {
      const action =
        confirmModalAction === "publish"
          ? communityActions.publishCommunityPost(params)
          : communityActions.unpublishCommunityPost(params);

      dispatch(action)
        .then((data) => {
          if (data.statusCode == 1) {
            this.closeConfirmModal();
            this.getCommunityPosts().finally(() => {
              this.setState({ loader: false });
            });
          } else {
            this.setState({
              errors: data.error ? data.error.responseMessage : "Action failed",
              loader: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            errors:
              (err && err.response && err.response.data
                ? err.response.data.responseMessage
                : "Something went wrong") || "",
            loader: false,
          });
        });
    });
  };

  sendToParent = (e) => {
    this.setState({ loader: true });
    this.getCommunityPosts();
  };

  changeName = (event) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      search: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name);
      }, 1000),
    });
  };

  handleSort = (sortField) => {
    this.setState(
      {
        loader: true,
        sortField,
        sortType: this.state.sortType === 1 ? -1 : 1,
      },
      () => this.getCommunityPosts()
    );
  };

  render() {
    let {
      userInfo,
      errors,
      count,
      pageNo,
      totalCount,
      showConfirmModal,
      confirmModalAction,
      confirmModalTitle,
      confirmModalMessage,
    } = this.state;

    return (
      <>
        <Sidebar />
        <div className="body_container">
          <div className="header_search header_search_custom ">
            <div className="row mb-3 mx-0 justify-content-between">
              <div className="col-md-7">
                <div className="row mb-3 gap-4 gap-md-0">
                  <div className="col-md-4 px-4">
                    <div className="count-list">
                      <div>
                        <div>
                          <span className="user-icon icon-blue m-lr-auto">
                            <DashboardIcon />
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-4">
                          <h6 className="mb-0">Total Posts</h6>
                          <h6 className="mb-0">{totalCount}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 px-0 d-flex flex-column justify-content-end">
                {/* <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback max-md-hidden"></span>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    name={"search"}
                    onChange={this.changeName}
                  />
                </div> */}
                <div className="d-flex align-items-center justify-content-end mt-4 mb-1">
                  <i className="fas fa-filter text_dark d-inline-block"></i>
                  <span className="mb-0 ml-2">Filter by Category</span>
                </div>
                <select
                  name="postType"
                  value={this.state.postType}
                  onChange={this.handlePostType}
                  className="d-flex justify-content-end min-w-100 outline-none"
                  style={{
                    padding: "8px 10px",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  <option value="">Select</option>
                  <option value="Dating Advice">Dating Advice</option>
                  <option value="Safety Warning">Safety Warning</option>
                  <option value="Location Recommendation">
                    Location Recommendation
                  </option>
                  <option value="Success Story">Success Story</option>
                  <option value="General">General</option>
                </select>
              </div>
            </div>
          </div>
          <div>
            <div className="body_inner_wrapper">
              {this.state.loader ? (
                <Loader />
              ) : (
                <>
                  <header className="header_content">
                    <p>Users</p>

                    <div className="d-flex text-nowrap header_btn"></div>
                  </header>

                  <div className="main_content">
                    <div className="table-responsive">
                      <table className="table cm_bottom_space">
                        <thead>
                          <tr className="broder_top_0">
                            <th scope="col" className="ws-nowrap">
                              S. No.
                            </th>
                            <th
                              scope="col"
                              onClick={() => this.handleSort("createdAt")}
                            >
                              Created On
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th
                              scope="col"
                              onClick={() => this.handleSort("userId")}
                            >
                              Created By
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th
                              scope="col"
                              onClick={() => this.handleSort("title")}
                            >
                              Title
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th
                              scope="col"
                              onClick={() => this.handleSort("story")}
                            >
                              Description
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>

                            <th
                              scope="col"
                              className="ws-nowrap"
                              onClick={() => this.handleSort("postType")}
                            >
                              Category
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th scope="col" className="ws-nowrap">
                              Location
                            </th>
                            <th
                              scope="col"
                              className="ws-nowrap"
                              onClick={() => this.handleSort("likesCount")}
                            >
                              Likes count
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th
                              scope="col"
                              className="ws-nowrap"
                              onClick={() => this.handleSort("reportCount")}
                            >
                              Report count
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th
                              scope="col"
                              className="ws-nowrap"
                              onClick={() => this.handleSort("isPublished")}
                            >
                              Status
                              <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                            </th>
                            <th scope="col" className="ws-nowrap">
                              Publish / Unpublish
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {!_.isEmpty(userInfo) &&
                            userInfo.map((item, i) => {
                              return (
                                <tr key={item._id}>
                                  <td>{count * (pageNo - 1) + (i + 1)}</td>
                                  <td>{this.ConvertDate(item.createdAt)}</td>
                                  <td className="capitalize min-w-150">
                                    {item?.userId
                                      ? (item?.userId?.firstName || "") +
                                        " " +
                                        (item?.userId?.lastName || "")
                                      : "-"}
                                  </td>
                                  <td className="capitalize min-w-150">
                                    {item?.title ?? "-"}
                                  </td>
                                  {/* <td className="capitalize min-w-200">
                                    <div className="overflow-auto mh-84 scrollbar-hide">
                                      {item?.story ?? "-"}
                                    </div>
                                  </td> */}
                                  <td className="capitalize min-w-200">
                                    {item?.story ? (
                                      <span style={{ whiteSpace: "normal" }}>
                                        {this.truncateText(item.story, 50)}

                                        {item.story.length > 10 && (
                                          <a
                                            href="#"
                                            className="ml-1 text-primary"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.openStoryModal(item.story);
                                            }}
                                          >
                                            Read more
                                          </a>
                                        )}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td className="capitalize min-w-150">
                                    {item?.postType ?? "-"}
                                  </td>
                                  <td className="capitalize min-w-150">
                                    {item?.state && item?.city
                                      ? `${item?.city}, ${item?.state}`
                                      : "-"}
                                  </td>
                                  <td>{item?.likesCount ?? "-"}</td>
                                  <td>{item?.reportCount ?? "-"}</td>
                                  <td className="capitalize">
                                    {item?.isPublished === true
                                      ? "Published"
                                      : "Unpublished"}
                                  </td>
                                  <td>
                                    {item?.isPublished ? (
                                      <button
                                        type="button"
                                        className="btn btn-link p-0 border-0"
                                        aria-label="Unpublish dish"
                                        title="Unpublish"
                                        onClick={() =>
                                          this.openConfirmModal(
                                            item._id,
                                            "unpublish"
                                          )
                                        }
                                      >
                                        <i
                                          className="fas fa-times-circle text-danger"
                                          style={{ fontSize: "20px" }}
                                        ></i>
                                      </button>
                                    ) : (
                                      // 🟢 PUBLISH
                                      <button
                                        type="button"
                                        className="btn btn-link p-0 border-0"
                                        aria-label="Publish dish"
                                        title="Publish"
                                        onClick={() =>
                                          this.openConfirmModal(
                                            item._id,
                                            "publish"
                                          )
                                        }
                                      >
                                        <i
                                          className="fas fa-check-circle text-success"
                                          style={{ fontSize: "20px" }}
                                        ></i>
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>

                      {userInfo && userInfo.length ? (
                        <div className="d-flex justify-content-end cm-pagination">
                          {/*{this.state.userListCount}*/}
                          <Pagination
                            itemClassPrev={"prevClass"}
                            itemClassNext={"nextClass"}
                            activePage={this.state.pageNo}
                            itemsCountPerPage={this.state.count}
                            totalItemsCount={this.state.userListCount}
                            pageRangeDisplayed={3}
                            onChange={this.handlePageChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {_.isEmpty(this.state.userInfo) ? (
                        <h3 className="text-center">No data found</h3>
                      ) : (
                        ""
                      )}
                      {errors ? (
                        <div className="text-center error ">{errors}</div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <Modal
                    show={showConfirmModal}
                    onHide={this.closeConfirmModal}
                    centered
                    className="cm_order_view dlt_item"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <p>{confirmModalMessage}</p>
                    </Modal.Body>
                    <Modal.Footer>
                      <div className="footer_btn_wrapper button_space">
                        <Button
                          variant={
                            this.state.confirmModalAction === "publish"
                              ? "success"
                              : "danger"
                          }
                          onClick={this.handleConfirmAction}
                          onMouseEnter={(e) => {
                            const btn = e.currentTarget;
                            if (this.state.confirmModalAction === "publish") {
                              btn.style.backgroundColor = "#218838";
                              btn.style.borderColor = "#1e7e34";
                            } else {
                              btn.style.backgroundColor = "#c82333";
                              btn.style.borderColor = "#bd2130";
                            }
                          }}
                          onMouseLeave={(e) => {
                            const btn = e.currentTarget;
                            if (this.state.confirmModalAction === "publish") {
                              btn.style.backgroundColor = "#28a745";
                              btn.style.borderColor = "#28a745";
                            } else {
                              btn.style.backgroundColor = "#dc3545";
                              btn.style.borderColor = "#dc3545";
                            }
                          }}
                        >
                          {this.state.confirmModalAction === "publish"
                            ? "Publish"
                            : "Unpublish"}
                        </Button>
                        <Button variant="dark" onClick={this.closeConfirmModal}>
                          Cancel
                        </Button>
                      </div>
                    </Modal.Footer>
                  </Modal>

                  <Modal
                    show={this.state.showStoryModal}
                    onHide={this.closeStoryModal}
                    centered
                    size="lg"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Description</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div style={{ whiteSpace: "pre-wrap", maxHeight: "500px", overflowY: "auto" }}>
                        {this.state.selectedStory}
                      </div>
                    </Modal.Body>
                  </Modal>
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

// export default

function mapStateToProps(state) {
  const { props, login, user, mapReducer } = state;
  return {
    props,
    login,
    user,
    mapReducer,
  };
}

export default connect(mapStateToProps)(CommunityList);
// export default Settings
